//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "PVS",
  data() {
    return {
      form: {
        f1: "",
        f2: "",
        f3: "",
        f4: "",
        f5: "",
        f6: "",
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        { value: "0", name: "无" },
        { value: "1", name: "刺激后运动" },
        { value: "2", name: "无目的的随意运动" },
        { value: "3", name: "有目的的随意运动" },
      ],
      dataList2: [
        { value: "0", name: "无" },
        { value: "1", name: "不持续眼球跟踪" },
        { value: "2", name: "持续眼球跟踪" },
        { value: "3", name: "有意注视" },
      ],
      dataList3: [
        { value: "0", name: "无" },
        { value: "1", name: "微弱动作" },
        { value: "2", name: "能执行简单命令" },
        { value: "3", name: "能执行各种指令" },
      ],
      dataList4: [
        { value: "0", name: "胃管营养" },
        { value: "1", name: "能吞咽液体" },
        { value: "2", name: "能吞咽稠食" },
        { value: "3", name: "能咀嚼" },
      ],
      dataList5: [
        { value: "0", name: "无" },
        { value: "1", name: "偶流泪" },
        { value: "2", name: "能哭笑" },
        { value: "3", name: "正常情感反应" },
      ],
      dataList6: [
        { value: "0", name: "无" },
        { value: "1", name: "能哼哼" },
        { value: "2", name: "能说单词" },
        { value: "3", name: "能说整句" },
      ],
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let result = 0;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
        result += Number(form[key]);
      }
      console.log(result);
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Neuro/PVS.vue